<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `transaction/task/${inputs.id}` : `transaction/task`"
			>
				<!-- Date -->
				<div class="form-group row align-items-center">
					<label for="inputs_assigned_date" class="col-sm-3 mb-0"> Date </label>
					<app-input
						id="inputs_assigned_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.assigned_date"
						placeholder="Date"
						:disabled="true"
						:required="true"
					/>
				</div>
				<!-- Task -->
				<div class="form-group row align-items-center">
					<label for="inputs_task" class="col-sm-3 mb-0">
						Task
					</label>
					<app-input
						id="inputs_task"
						class="col-sm-9"
						type="text"
						v-model="inputs.title"
						placeholder="Task"
						:required="true"
					/>
				</div>
				<!-- Assigned By -->
				<div class="form-group row align-items-center">
					<label for="inputs_owner_id" class="col-sm-3 mb-0">
						Assigned By
					</label>
					<app-input
						id="inputs_owner_id"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.owner_id"
						:list="assignedByLists"
						placeholder="Assigned By"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "LogTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			assignedByLists: [],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData()
	},
	methods: {
		async fetchData() {
			try {
				let [
					userResponse
				] = await Promise.all([
					axios.get("/user-list")
				]);

				userResponse.data.data.forEach((item) => {
					this.assignedByLists.push({
						id: item.id,
						value: item.full_name,
					});
				});

			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
